import { Component, Input } from '@angular/core';
import { GalleryImage } from '../../models/gallery-image.model';
import { ImageModalComponent } from '../image-modal/image-modal.component';

@Component({
  selector: 'pc-photo-gallery',
  standalone: true,
  imports: [
    ImageModalComponent
  ],
  templateUrl: './photo-gallery.component.html',
  styleUrl: './photo-gallery.component.scss'
})
export class PhotoGalleryComponent {
  @Input() imageList: GalleryImage[] = [];
  selectedImage: GalleryImage | null = null;

  openModal(image: GalleryImage): void {
    this.selectedImage = image;
  }

  closeModal(): void {
    this.selectedImage = null;
  }
}
